import { render } from "./UserTable.vue?vue&type=template&id=e0a42e86"
import script from "./UserTable.vue?vue&type=script&lang=ts"
export * from "./UserTable.vue?vue&type=script&lang=ts"
script.render = render

export default script